import React from 'react';
import { connect } from 'react-redux';
import { BigBreadcrumbs } from '../../../components';
import { requestUserInfo } from '../../../store/current-user/CurrentUserActions';
import { hashHistory, Link } from 'react-router';
import Gallery from 'react-grid-gallery';
import Dropzone from 'react-dropzone';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import { toast } from 'react-toastify';
import ClinicShutdownForm from '../components/ClinicShutdownForm';
import ContactForm from '../components/ContactForm';
import Moment from '../../../components/utils/Moment';
import { humanFileSize } from '../../../components/utils/format';
import {
  requestLocationDetails,
  requestLocationPhotoGalleryFiles,
  uploadLocationPhotoGalleryFiles,
  getLocationPhotoGalleryFile,
  deleteLocationPhotoGalleryFile,
  requestShutdownHours,
  updateShutdownHours,
  requestLocationFiles,
  uploadLocationFiles,
  getLocationFile,
  deleteLocationFile,
  previewLocationFile,
  updateLocationFileDescription,
  requestLocationFacilityFiles,
  uploadLocationFacilityFiles,
  updateFacilityFileInfo,
  getFacilityFile,
  previewFacilityFile,
  deleteFacilityFile
} from '../../../store/location-manager/LocationManagerActions';
import * as moment from 'moment';
import ReactTable from 'react-table';
import FileViewer from 'react-file-viewer';
import { isStaff, isExecutive } from '../../../store/current-user/CurrentUserSelectors';
import { requestLocationContacts } from '../../../store/contact-manager/ContactManagerActions';
import { requestContactTypes, requestContactDetails, updateContactDetails, requestFacilityContacts, deleteFacilityContact, requestDocumentTypes } from '../../../store/contact-manager';
import { requestClinicLocationsTypeahead } from '../../../store/location-manager/LocationManagerActions';
import { requestClientsTypeahead } from '../../../store/client-manager/ClientManagerActions';
import { requestPatientsTypeahead } from '../../../store/patients/PatientsActions';
import { requestReferralsTypeahead } from '../../../store/referral-directory/ReferralDirectoryActions';

class LocationManagerDetail extends React.Component {
  constructor() {
    super();
    this.disposal = null;

    this.state = {
      files: [],
      gallery: [],
      showUpload: false,
      currentImage: null,
      showClinicShutdown: false,
      locationfiles: [],
      showlocationUpload: false,
      showPreview: false,
      fileName: null,
      fileType: null,
      showContactForm: false,
      facilityfiles: [],
      showFacilityUpload: false,
    };

    this.addImageToGallery = this.addImageToGallery.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.onCurrentImageChange = this.onCurrentImageChange.bind(this);
    this.getPhotoGalleryFiles = this.getPhotoGalleryFiles.bind(this);

    this.removeFileFromUploadList = this.removeFileFromUploadList.bind(this);
    this.renderEditable = this.renderEditable.bind(this);
    this.renderEditableTags = this.renderEditableTags.bind(this);
    this.renderFacilityEditable = this.renderFacilityEditable.bind(this);
    this.renderEditableDocumentType = this.renderEditableDocumentType.bind(this);
    this.renderEditableNotify = this.renderEditableNotify.bind(this);
  }

  componentWillMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.params.clinicLocationID !== prevProps.params.clinicLocationID
    ) {
      this.loadData();
    }
  }

  loadData() {
    this.props.getLocationDetails(this.props.params.clinicLocationID, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getLocationShutdownHours(this.props.params.clinicLocationID, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.getPhotoGalleryFiles();
    this.props.getCurrentUser();
    this.props.getLocationFiles(this.props.params.clinicLocationID, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getLocationContacts(this.props.params.clinicLocationID, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getFacilities({
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getDocumentTypes({
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getFacilityFiles(this.props.params.clinicLocationID, {
      tenantId: this.props.user.queryParams.tenantId,
    });
  }

  getPhotoGalleryFiles(refresh = false) {
    this.props
      .getPhotoGalleryFiles(this.props.params.clinicLocationID, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((res) => {
        if (res.payload && res.payload.data) {
          if (refresh) {
            this.setState({ gallery: [] });
          }
          res.payload.data.forEach((fileName) =>
            this.props
              .getPhotoGalleryFile(
                this.props.params.clinicLocationID,
                {
                  tenantId: this.props.user.queryParams.tenantId,
                },
                fileName,
              )
              .then((response) => {
                const blob = response.payload;

                let image = new Image();
                image.src = URL.createObjectURL(blob);
                if (this.disposal) {
                  $('.disposal').append(image);
                }

                this.addImageToGallery({
                  src: image.src,
                  thumbnail: image.src,
                  thumbnailWidth: 300,
                  // thumbnailHeight: 'auto',
                  caption: fileName,
                });
              }),
          );
        }
      });
  }

  editLocation = (clinicLocationID) => {
    hashHistory.push(`/location-manager/location/${clinicLocationID}`);
  };
  onCurrentImageChange(index) {
    this.setState({ currentImage: index });
  }

  deleteImage(image) {
    if (window.confirm(`Are you sure you want to delete image?`)) {
      const gallery = this.state.gallery.slice();
      gallery.splice(this.state.currentImage, 1);

      const item = this.state.gallery[this.state.currentImage];
      this.props
        .deletePhotoGalleryFile(
          this.props.params.clinicLocationID,
          {
            tenantId: this.props.user.queryParams.tenantId,
          },
          item.caption,
        )
        .then(() => {
          this.setState({
            gallery: gallery,
          });
        });
    }
  }

  addImageToGallery(item) {
    const { gallery } = this.state;
    this.setState({
      gallery: [...gallery, item],
    });
  }

  onDrop(files) {
    const filesToAdd = _.difference(files, this.state.files);
    this.setState({ files: this.state.files.concat(filesToAdd) });
  }

  onCancel() {
    this.setState({
      files: [],
    });
  }

  showModal() {
    this.setState({ showUpload: true });
  }

  closeModal() {
    this.setState({ showUpload: false });
    this.onCancel();
  }

  onLocationDrop(locationfiles) {
    const filesToAdd = _.difference(locationfiles, this.state.locationfiles);
    this.setState({
      locationfiles: this.state.locationfiles.concat(filesToAdd),
    });
  }

  onLocationCancel() {
    this.setState({
      locationfiles: [],
    });
  }

  showLocationModal() {
    this.setState({ showlocationUpload: true });
  }

  closeLocationModal() {
    this.setState({ showlocationUpload: false });
    this.onCancel();
  }

  showFacilityModal() {
    this.setState({ showFacilityUpload: true });
  }

  closeFacilityModal() {
    this.setState({ showFacilityUpload: false });
    this.onCancel();
  }

  onFacilityDrop(facilityfiles) {
    const filesToAdd = _.difference(facilityfiles, this.state.facilityfiles);
    this.setState({
      facilityfiles: this.state.facilityfiles.concat(filesToAdd),
    });
  }

  onFacilityCancel() {
    this.setState({
      facilityfiles: [],
    });
  }

  showClientEscalationForm = (escalationId, employerCodeNumber) => {
    hashHistory.push(
      `/client-manager/escalation/${escalationId}/${employerCodeNumber}`,
    );
  };

  showPatientEscalationForm = (escalationId, masterPatientId) => {
    hashHistory.push(`/patients/escalation/${escalationId}/${masterPatientId}`);
  };

  showLocationEscalationForm = (escalationId, locationId) => {
    hashHistory.push(
      `/location-escalation/escalation/${escalationId}/${locationId}`,
    );
  };

  showContactForm = (contactId, mode, clinicLocationID) => {
    hashHistory.push(`/location-manager/contact/${contactId}/${mode}/${clinicLocationID}`);
  };

  showClinicShutdownModal() {
    this.setState({ showClinicShutdown: true });
  }

  closeClinicShutdownModal() {
    this.setState({ showClinicShutdown: false });
  }

  onSubmit = (date, hours, reason) => {
    var newDate = moment(date).format('MM/DD/YYYY');
    this.props
      .updateShutdownHours(this.props.params.clinicLocationID, {
        tenantId: this.props.user.queryParams.tenantId,
        date: newDate,
        hours: hours,
        reason: reason,
      })
      .then((result) => {
        this.setState({ showClinicShutdown: false });
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Hours saved.');
          this.props.getLocationShutdownHours(
            this.props.params.clinicLocationID,
            {
              tenantId: this.props.user.queryParams.tenantId,
            },
          );
        }
      });
  };

  removeFileFromUploadList(fileName) {
    this.setState({
      files: this.state.files.filter((file) => file.name !== fileName),
    });
  }

  removeLocationFileFromUploadList(fileName) {
    this.setState({
      locationfiles: this.state.locationfiles.filter(
        (file) => file.name !== fileName,
      ),
    });
  }

  removeFacilityFileFromUploadList(fileName) {
    this.setState({
      facilityfiles: this.state.facilityfiles.filter(
        (file) => file.name !== fileName,
      ),
    });
  }

  onStartUpload() {
    this.props
      .uploadPhotoGalleryFiles(
        this.props.params.clinicLocationID,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        this.state.files,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('Files have been uploaded.');
          this.setState({ showUpload: false, files: [] });
          this.getPhotoGalleryFiles(true);
        }
      });
  }

  onStartLocationUpload() {
    this.props
      .uploadLocationFiles(
        this.props.params.clinicLocationID,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        this.state.locationfiles,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('Files have been uploaded.');
          this.setState({ showlocationUpload: false, locationfiles: [] });
          this.props.getLocationFiles(this.props.params.clinicLocationID, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  onStartFacilityUpload() {
    this.props
      .uploadFacilityFiles(
        this.props.params.clinicLocationID,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        this.state.facilityfiles,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('Files have been uploaded.');
          this.setState({ showFacilityUpload: false, facilityfiles: [] });
          this.props.getFacilityFiles(this.props.params.clinicLocationID, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  downloadFile(fileName) {
    this.props
      .getLocationFile(
        this.props.params.clinicLocationID,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        fileName,
      )
      .then((response) => {
        const blob = response.payload;
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  previewFile(filename) {
    this.props
      .previewLocationFile(
        this.props.params.clinicLocationID,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        filename,
      )
      .then((response) => {
        const blob = response.payload;
        var type = filename.substring(
          filename.lastIndexOf('.') + 1,
          filename.length,
        );
        this.setState({ fileName: URL.createObjectURL(blob) });
        this.setState({ fileType: type });
        this.setState({ showPreview: true });
      });
  }

  closePreview() {
    this.setState({ showPreview: false });
  }

  downloadFacilityFile(fileName) {
    this.props
      .getFacilityFile(
        this.props.params.clinicLocationID,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        fileName,
      )
      .then((response) => {
        const blob = response.payload;
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  previewFacilityFile(filename) {
    this.props
      .previewFacilityFile(
        this.props.params.clinicLocationID,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        filename,
      )
      .then((response) => {
        const blob = response.payload;
        var type = filename.substring(
          filename.lastIndexOf('.') + 1,
          filename.length,
        );
        this.setState({ fileName: URL.createObjectURL(blob) });
        this.setState({ fileType: type });
        this.setState({ showPreview: true });
      });
  }

  deleteFacilityFile(fileName) {
    this.props
      .deleteFacilityFile(
        this.props.params.clinicLocationID,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        fileName,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('File has been deleted.');
          this.props.getFacilityFiles(this.props.params.clinicLocationID, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  deleteFile(fileName) {
    this.props
      .deleteLocationFile(
        this.props.params.clinicLocationID,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        fileName,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('File has been deleted.');
          this.props.getLocationFiles(this.props.params.clinicLocationID, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  updateFileInfo(fileName, data, otherAttrs) {
    const newInfo = {
      tags: otherAttrs.tags,
      title: otherAttrs.title,
      description: otherAttrs.description,
      ...data,
    };
    this.props
      .updateLocationFileInfo(
        this.props.params.clinicLocationID,
        fileName,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        newInfo,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('File has been updated.');
          this.props.getLocationFiles(this.props.params.clinicLocationID, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  updateFacilityInfo(fileName, data, otherAttrs) {
    const newInfo = {
      expirationDate: otherAttrs.expirationDate,
      documentTypeId: otherAttrs.documentTypeId,
      isNotify: otherAttrs.isNotify,
      advanceNotice: otherAttrs.advanceNotice,
      notificationEmail: otherAttrs.notificationEmail,
      description: otherAttrs.description,
      ...data,
    };
    this.props
      .updateFacilityFileInfo(
        this.props.params.clinicLocationID,
        fileName,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        newInfo,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('File has been updated.');
          this.props.getFacilityFiles(this.props.params.clinicLocationID, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  renderEditable(cellInfo) {
    return (
      <div
        style={{ backgroundColor: 'rgba(255,255,255,0)' }}
        contentEditable={!isExecutive}
        suppressContentEditableWarning
        onBlur={(e) => {
          const text = $('<p/>').html(e.target.innerHTML).text();
          this.updateFileInfo(
            cellInfo.original.fileName,
            {
              [cellInfo.column.id]: text,
            },
            cellInfo.original,
          );
        }}
        dangerouslySetInnerHTML={{
          __html: cellInfo.original[cellInfo.column.id],
        }}
      />
    );
  }

  renderEditableTags(cellInfo) {
    return (
      <div
        style={{ backgroundColor: 'rgba(255,255,255,0)' }}
        contentEditable={!isExecutive}
        suppressContentEditableWarning
        onBlur={(e) => {
          const text = $('<p/>').html(e.target.innerHTML).text();
          this.updateFileInfo(
            cellInfo.original.fileName,
            {
              [cellInfo.column.id]: text.split(','),
            },
            cellInfo.original,
          );
        }}
        dangerouslySetInnerHTML={{
          __html: cellInfo.original[cellInfo.column.id]
            ? cellInfo.original[cellInfo.column.id].join()
            : '',
        }}
      />
    );
  }

  renderFacilityEditable(cellInfo) {
    return (
      <div
        style={{ backgroundColor: 'rgba(255,255,255,0)' }}
        contentEditable
        suppressContentEditableWarning
        onBlur={(e) => {
          const text = $('<p/>').html(e.target.innerHTML).text();
          this.updateFacilityInfo(
            cellInfo.original.fileName,
            {
              [cellInfo.column.id]: text,
            },
            cellInfo.original,
          );
        }}
        dangerouslySetInnerHTML={{
          __html: cellInfo.original[cellInfo.column.id],
        }}
      />
    );
  }

  renderEditableDocumentType(cellInfo) {
    const { documentTypes } = this.props.contacts;
    return (
      <div>
        <select className="form-control" value={cellInfo.original.documentTypeId ? cellInfo.original.documentTypeId : ''} onChange={(e) => {
          this.updateFacilityInfo(
            cellInfo.original.fileName,
            {
              documentTypeId: e.target.value,
            },
            cellInfo.original,
          );
        }}>
          <option value="">Select</option>
          {documentTypes && documentTypes.map((type, index) => (
            <option key={index} value={type.id}>{type.name}</option>
          ))}
        </select>
      </div>
    );
  }

  renderEditableNotify(cellInfo) {
    return (
      <div>
        <select className="form-control" value={cellInfo.original.isNotify} onChange={(e) => {
          this.updateFacilityInfo(
            cellInfo.original.fileName,
            {
              isNotify: e.target.value,
            },
            cellInfo.original,
          );
        }}>
          <option value="N">No</option>
          <option value="Y">Yes</option>
        </select>
      </div>
    );
  }

  showContactModal = (contactId) => {
    this.setState({ showContactForm: true });
    this.props.getContact(contactId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
  };

  onFormSubmit = (values) => {
    this.props
      .updateContactDetails(values, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Contact has been saved.');
          this.setState({ showContactForm: false });
          this.props.getFacilities({
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  };

  onFormCancel = () => {
    this.setState({ showContactForm: false });
  };

  closeContactForm() {
    this.setState({ showContactForm: false });
  }

  deleteContact = (contactId) => {
    this.props
      .deleteFacilityContact(contactId, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getFacilities({
          tenantId: this.props.user.queryParams.tenantId,
        }));
  };

  searchLocations = (search) => {
    return this.props
      .locationsTypeahead({
        tenantId: this.props.user.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ clinicLocationID: item.code, siteName: item.name }),
          );
        }
        return options;
      });
  };

  searchClients = (search) => {
    return this.props
      .clientsTypeahead({
        tenantId: this.props.user.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ clientID: item.code, employerCodeDescription: item.name }),
          );
        }
        return options;
      });
  };

  searchPatients = (search) => {
    return this.props
      .patientsTypeahead({
        tenantId: this.props.user.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({
              masterPatientID: item.id, fullName: item.name.substring(
                0,
                item.name.lastIndexOf('(') - 1,
              )
            }),
          );
        }
        return options;
      });
  };

  searchReferrals = (search) => {
    return this.props
      .referralsTypeahead({
        tenantId: this.props.user.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ referralID: item.id, resource: item.name }),
          );
        }
        return options;
      });
  };

  searchContactTypes = () => {
    return this.props
      .getContactTypes({
        tenantId: this.props.user.queryParams.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ typeID: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  render() {
    const {
      data: {
        details,
        shutdownhours,
        isDetailsLoading,
        isFilesUploading,
        locationfiles,
        isFilesLoading,
        isLocationFilesUploading,
        isFileUpdating,
        facilityfiles,
        isFacilityFilesUploading,
        isFacilityFilesLoading,
        isFacilityFilesUpdating
      },
      params,
      contacts,
      isExecutive,
      isStaff
    } = this.props;

    const info = details[params.clinicLocationID]
      ? details[params.clinicLocationID]
      : {};

    const filesToUpload = this.state.files.map((file) => (
      <li className="list-group-item" key={file.name}>
        <span className="filename">{file.name}</span>
        <a
          className="action btn btn-xs btn-danger"
          onClick={() => this.removeFileFromUploadList(file.name)}
        >
          <i className="fa fa-close" />
        </a>
        <span className="badge">{humanFileSize(file.size)} bytes</span>
      </li>
    ));

    const locationfilesToUpload = this.state.locationfiles.map((file) => (
      <li className="list-group-item" key={file.name}>
        <span className="filename">{file.name}</span>
        <a
          className="action btn btn-xs btn-danger"
          onClick={() => this.removeLocationFileFromUploadList(file.name)}
        >
          <i className="fa fa-close" />
        </a>
        <span className="badge">{humanFileSize(file.size)} bytes</span>
      </li>
    ));

    const facilityfilesToUpload = this.state.facilityfiles.map((file) => (
      <li className="list-group-item" key={file.name}>
        <span className="filename">{file.name}</span>
        <a
          className="action btn btn-xs btn-danger"
          onClick={() => this.removeFacilityFileFromUploadList(file.name)}
        >
          <i className="fa fa-close" />
        </a>
        <span className="badge">{humanFileSize(file.size)} bytes</span>
      </li>
    ));

    const acceptedFiles =
      'image/jpeg, image/png, image/gif, image/x-icon, application/pdf, application/msword, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text, application/vnd.ms-excel, application/x-photoshop, audio/mpeg, audio/x-m4a, application/ogg, video/mp4, video/mpeg4, video/x-m4v, video/quicktime, video/x-ms-wmv, video/avi, video/mpeg, video/ogg, video/3gpp, video/3gpp2';

    const locationacceptedFiles =
      'image/jpeg, image/png, image/gif, image/x-icon, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text, application/vnd.ms-excel, application/x-photoshop, audio/mpeg, audio/x-m4a, application/ogg, video/mp4, video/mpeg4, video/x-m4v, video/quicktime, video/x-ms-wmv, video/avi, video/mpeg, video/ogg, video/3gpp, video/3gpp2';

    return (
      <div id="content">
        <BigBreadcrumbs
          items={[
            'Administration',
            { title: 'Location Manager', route: '/location-manager' },
            'Detail',
          ]}
          icon="fa fa-fw fa-database"
          className=""
        />
        <div>
          {info && (
            <div>
              {/* product */}
              <div className="product-content product-wrap clearfix product-deatil">
                {info.clinicLocationID && (
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 col-xs-12">
                      <button disabled={isStaff || isExecutive}
                        className="btn btn-primary pull-right"
                        onClick={() => this.editLocation(info.clinicLocationID)}
                      >
                        <i className="fa fa-pencil" />
                      </button>
                      <h2 className="name">
                        {info.siteName}{' '}
                        {/* Client_Telemetry.ClinicLocations.SiteDescription */}
                        <small>
                          {info.clinicLocationID}
                          {/* Client_Telemetry.ClinicLocations.ClinicLocationID */}{' '}
                          | {info.siteDescription}{' '}
                        </small>
                        <small>
                          Location Code: {info.siteCode}{' '}
                          {/* Client_Telemetry.ClinicLocations.SiteCode */}
                        </small>
                        <small>
                          Practice Group: {info.practiceGroupName}{' '}
                          {/* Client_Telemetry.ClinicLocations.PracticeGroupName (Need to create field) */}{' '}
                          {/*(19381374137461076 Client_Telemetry.ClinicLocations.PracticeGroupName (Need to create field) ) */}
                          | Site Number: {info.siteNumber}{' '}
                          {/* Client_Telemetry.ClinicLocations.SiteNumber */}
                        </small>
                      </h2>
                      <hr className="simple" />
                    </div>
                    <div className="col-lg-7 col-sm-12 col-xs-12">
                      <h3 className="price-container">
                        Patients {/* NEED TO CONNECT TO THIS DATA */}
                        <small>Demographics</small>
                      </h3>
                      <div className="certified single">
                        <ul>
                          <li>
                            <a>
                              Total Patients
                              <span>
                                N/A{' '}
                                {/* lkp.WFL_Client_Matrix.EligibleEmployees */}
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <hr className="simple" />
                      <div className="description description-tabs">
                        <ul id="myTab" className="nav nav-tabs">
                          <li className="active">
                            <a
                              href="#information"
                              data-toggle="tab"
                              className="no-margin"
                            >
                              Location Information{' '}
                            </a>
                          </li>
                          <li>
                            <a href="#client" data-toggle="tab">
                              Clients
                            </a>
                          </li>
                          <li>
                            <a href="#team" data-toggle="tab">
                              Team
                            </a>
                          </li>
                          <li>
                            <a href="#clinicshutdown" data-toggle="tab">
                              Clinic Shutdown
                            </a>
                          </li>
                          <li>
                            <a href="#escalations" data-toggle="tab">
                              Escalations
                            </a>
                          </li>
                          <li>
                            <a href="#referrals" data-toggle="tab">
                              Referrals
                            </a>
                          </li>
                          <li>
                            <a href="#facilities" data-toggle="tab">
                              Facilities
                            </a>
                          </li>
                          <li className="">
                            <a href="#contacts" data-toggle="tab">
                              Contacts
                            </a>
                          </li>
                        </ul>
                        <div id="myTabContent" className="tab-content">
                          <div
                            className="tab-pane fade active in"
                            id="information"
                          >
                            <br />
                            <div className="certified">
                              <ul>
                                <li>
                                  <a>
                                    Status
                                    <span>
                                      {info.status ? info.status : '\u00A0'}
                                      {` `}
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a>
                                    Start Date
                                    <span>
                                      <Moment
                                        date={info.startDate}
                                        format="MM/DD/YYYY"
                                      />{' '}
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a>
                                    DPC
                                    <span>
                                      {info.DPC === 'Y' ? 'Yes' : 'No'}{' '}
                                      {/* lkp.WFL_Client_Matrix.VIShare */}
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a>
                                    Is Shared
                                    <span>
                                      {info.isShared === 'Y' ? 'Yes' : 'No'}{' '}
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a>
                                    Onsite/Nearsite
                                    <span>
                                      {info.siteType === null ? 'Not mentioned' : info.siteType[0].name}{' '}
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a>
                                    Reciprocity Agreements
                                    <span>
                                      {info.reciprocityAgreements === 'Y' ? 'Yes' : 'No'}{' '}
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <br />
                            <strong>
                              About {info.practiceGroupName}{' '}
                              {/* lkp.WFL_Client_Matrix.EmployerCodeDescription */}
                            </strong>
                            <div
                              dangerouslySetInnerHTML={{ __html: info.about }}
                            />
                          <br/>
                            {info.contacts &&
                              info.contacts.map((el, index) => (
                                <dl key={index}>
                                  <dt>
                                    {el.contact} {el.type}
                                  </dt>
                                  <dd>{el.description}</dd>
                                </dl>
                              ))}
                            <br />
                            <dl>
                              <dt>Address</dt>
                              <dd>
                                {info.completeAddress}{' '}
                                {/* NEED TO CREATE A DATA FIELD FOR THIS */}
                              </dd>
                              <br />
                              <dt>Phone Number</dt>
                              <dd>
                                {info.phoneNumber}{' '}
                                {/* NEED TO CREATE A DATA FIELD FOR THIS */}
                              </dd>
                              <br />
                              <dt>Fax</dt>
                              <dd>
                                {info.fax}{' '}
                                {/* NEED TO CREATE A DATA FIELD FOR THIS */}
                              </dd>
                              {/* <dd>
                              812-555-1212{" "}
                              <small>Main</small>
                            </dd>
                            <dd>
                              812-555-1213{" "}
                              <small>Fax</small>
                            </dd> */}
                              <br />
                            </dl>
                          </div>
                          <div className="tab-pane fade" id="client">
                            <br />
                            <div className="table-responsive">
                              {info.clinicLocationClients && (
                                <table className="table table-bordered table-condensed">
                                  <thead>
                                    <tr>
                                      <th>Client</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {info.clinicLocationClients &&
                                      info.clinicLocationClients.map(
                                        (el, i) => (
                                          <tr key={i}>
                                            <td>
                                              <Link
                                                to={`/client-manager/detail/${el.employerCodeNumber}`}
                                              >
                                                {el.employerCodeDescription}
                                                {' ('}
                                                {el.employerCodeNumber}
                                                {')'}
                                              </Link>
                                            </td>
                                            <td>
                                              <em>
                                                {el.isDefault ? 'Default' : ''}
                                              </em>
                                              {` `}
                                              <em>
                                                {el.isAnchorTenant
                                                  ? 'Anchor'
                                                  : ''}
                                              </em>
                                            </td>
                                          </tr>
                                        ),
                                      )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </div>
                          <div className="tab-pane fade" id="team">
                            {info.team && info.team.length > 0 ? '' : 'N/A'}
                            {info.team &&
                              info.team.map((el, i) => (
                                <dl key={i}>
                                  <dt>{el.teamName}</dt>
                                  <dd>{`${'Name: ' + el.firstName} ${el.lastName}`} | {`${'Hours Assigned: ' + el.hoursAssigned}`} | {`${el.workPhone ? ' Phone: ' + el.workPhone : el.mobilePhone ? ' Mobile: ' + el.mobilePhone : ''}`} | {`${'Email: ' + el.email}`} | {`${'Roles: ' + el.roles}`}</dd>
                                </dl>
                              ))}
                          </div>

                          <div className="tab-pane fade" id="clinicshutdown">
                            <dt>Clinic Shutdown Hours</dt>
                            <br />
                            <ReactTable
                              ref={(instance) => {
                                this.table = instance;
                              }}
                              pageSize={10}
                              minRows={1}
                              loading={isDetailsLoading}
                              data={shutdownhours ? shutdownhours.list : []}
                              columns={[
                                {
                                  Header: 'Date',
                                  accessor: 'date',
                                  Cell: (row) => (
                                    <Moment
                                      date={row.original.date}
                                      format="MM/DD/YYYY"
                                    />
                                  ),
                                },
                                {
                                  Header: 'Hours Missed',
                                  accessor: 'hours',
                                },
                                {
                                  Header: 'Reason',
                                  accessor: 'reason',
                                },
                              ]}
                              className="-striped -highlight"
                              sortable={true}
                            />
                            <br />
                            <button disabled={isStaff || isExecutive}
                              className="btn btn-default"
                              onClick={this.showClinicShutdownModal.bind(this)}
                            >
                              <i className="fa fa-plus" /> Add Hours
                            </button>
                          </div>
                         
                          <div className="tab-pane fade" id="escalations">
                            <dt>Patient Escalations</dt>
                            <br />
                            <ReactTable
                              ref={(instance) => {
                                this.table = instance;
                              }}
                              pageSize={10}
                              minRows={1}
                              loading={isDetailsLoading}
                              data={info.patientEscalations ? info.patientEscalations : []}
                              columns={[
                                {
                                  Header: '',
                                  id: 'actions',
                                  width: 35,
                                  sortable: false,
                                  Cell: (row) => (
                                    <span>
                                      <button disabled={isStaff || isExecutive}
                                        className="btn btn-default btn-xs"
                                        onClick={() =>
                                          this.showPatientEscalationForm(
                                            row.original.escalationId,
                                            row.original.masterPatientId,
                                          )
                                        }
                                      >
                                        <i className="fa fa-pencil" />
                                      </button>
                                    </span>
                                  ),
                                },
                                {
                                  Header: 'Escalation Id',
                                  id: 'escalationId',
                                  accessor: 'escalationId',
                                  show: false,
                                },
                                {
                                  Header: 'MasterPatientId',
                                  id: 'masterPatientId',
                                  accessor: 'masterPatientId',
                                  show: false,
                                },
                                {
                                  Header: 'Date Reported',
                                  accessor: 'dateReported',
                                  Cell: (row) => (
                                    <Moment
                                      date={row.original.dateReported}
                                      format="MM/DD/YYYY HH:mm"
                                    />
                                  ),
                                },
                                {
                                  Header: 'Issue Name',
                                  accessor: 'issueName',
                                },
                                {
                                  Header: 'Issue Type',
                                  accessor: 'issueType',
                                },
                                {
                                  Header: 'Patient',
                                  accessor: 'patientName',
                                },
                                {
                                  Header: 'Description',
                                  accessor: 'description',
                                },
                                {
                                  Header: 'Resolved',
                                  accessor: 'resolved',
                                },
                              ]}
                              className="-striped -highlight"
                              sortable={true}
                              defaultSorted={[
                                {
                                  id: 'dateReported',
                                  desc: true,
                                },
                              ]}
                            />

                            <br/>
                            <br />
                            <dt>Client Escalations</dt>
                            <br />
                            <ReactTable
                              ref={(instance) => {
                                this.table = instance;
                              }}
                              pageSize={10}
                              minRows={1}
                              loading={isDetailsLoading}
                              data={info.clientEscalations ? info.clientEscalations : []}
                              columns={[
                                {
                                  Header: '',
                                  id: 'actions',
                                  width: 35,
                                  sortable: false,
                                  Cell: (row) => (
                                    <span>
                                      <button disabled={isStaff || isExecutive}
                                        className="btn btn-default btn-xs"
                                        onClick={() =>
                                          this.showClientEscalationForm(
                                            row.original.escalationId,
                                            row.original.employerCodeNumber,
                                          )
                                        }
                                      >
                                        <i className="fa fa-pencil" />
                                      </button>
                                    </span>
                                  ),
                                },
                                {
                                  Header: 'Escalation Id',
                                  id: 'escalationId',
                                  accessor: 'escalationId',
                                  show: false,
                                },
                                {
                                  Header: 'EmployerCodeNumber',
                                  id: 'employerCodeNumber',
                                  accessor: 'employerCodeNumber',
                                  show: false,
                                },
                                {
                                  Header: 'Date Reported',
                                  accessor: 'dateReported',
                                  Cell: (row) => (
                                    <Moment
                                      date={row.original.dateReported}
                                      format="MM/DD/YYYY HH:mm"
                                    />
                                  ),
                                },
                                {
                                  Header: 'Issue Name',
                                  accessor: 'issueName',
                                },
                                {
                                  Header: 'Issue Type',
                                  accessor: 'issueType',
                                },
                                {
                                  Header: 'Client',
                                  accessor: 'clientName',
                                },
                                {
                                  Header: 'Description',
                                  accessor: 'description',
                                },
                                {
                                  Header: 'Resolved',
                                  accessor: 'resolved',
                                },
                              ]}
                              className="-striped -highlight"
                              sortable={true}
                              defaultSorted={[
                                {
                                  id: 'dateReported',
                                  desc: true,
                                },
                              ]}
                            />

                            <br />
                            <br />
                            <dt>Location Escalations</dt>
                            <br />
                            <ReactTable
                              ref={(instance) => {
                                this.table = instance;
                              }}
                              pageSize={10}
                              minRows={1}
                              loading={isDetailsLoading}
                              data={info.locationEscalations ? info.locationEscalations : []}
                              columns={[
                                {
                                  Header: '',
                                  id: 'actions',
                                  width: 35,
                                  sortable: false,
                                  Cell: (row) => (
                                    <span>
                                      <button disabled={isStaff || isExecutive}
                                        className="btn btn-default btn-xs"
                                        onClick={() =>
                                          this.showLocationEscalationForm(
                                            row.original.escalationId,
                                            row.original.locationId,
                                          )
                                        }
                                      >
                                        <i className="fa fa-pencil" />
                                      </button>
                                    </span>
                                  ),
                                },
                                {
                                  Header: 'Escalation Id',
                                  id: 'escalationId',
                                  accessor: 'escalationId',
                                  show: false,
                                },
                                {
                                  Header: 'Location Id',
                                  id: 'locationId',
                                  accessor: 'locationId',
                                  show: false,
                                },
                                {
                                  Header: 'Date Reported',
                                  accessor: 'dateReported',
                                  Cell: (row) => (
                                    <Moment
                                      date={row.original.dateReported}
                                      format="MM/DD/YYYY HH:mm"
                                    />
                                  ),
                                },
                                {
                                  Header: 'Issue Name',
                                  accessor: 'issueName',
                                },
                                {
                                  Header: 'Issue Type',
                                  accessor: 'issueType',
                                },
                                {
                                  Header: 'Location',
                                  accessor: 'locationName',
                                },
                                {
                                  Header: 'Description',
                                  accessor: 'description',
                                },
                                {
                                  Header: 'Resolved',
                                  accessor: 'resolved',
                                },
                              ]}
                              className="-striped -highlight"
                              sortable={true}
                              defaultSorted={[
                                {
                                  id: 'dateReported',
                                  desc: true,
                                },
                              ]}
                            />
                          </div>

                          <div className="tab-pane fade" id="referrals">
                            <br />
                            <div className="table-responsive">
                              {info.referrals && (
                                <table className="table table-bordered table-condensed">
                                  <thead>
                                    <tr>
                                      <th>Organization</th>
                                      <th>Website</th>
                                      <th>Phone</th>
                                      <th>ReferralType</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {info.referrals &&
                                      info.referrals.map(

                                        (el, i) => (
                                          <tr key={i}>

                                            <td>
                                              <Link
                                                to={`/referral-directory/referral/${el.id}/ReadOnly`}
                                              >
                                                {el.organization}
                                              </Link>
                                            </td>
                                            <td>
                                              <span>{el.website}</span>
                                            </td>
                                            <td>
                                              <span>{el.phone}</span>
                                            </td>
                                            <td>
                                              <span>{el.referralType}</span>
                                            </td>
                                          </tr>
                                        ),
                                      )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </div>

                          <div className="tab-pane fade" id="facilities">
                            <br />
                            <button disabled={isStaff || isExecutive}
                              className="btn btn-default"
                              onClick={() => this.showContactModal('00000000-0000-0000-0000-000000000000')}
                            >
                              <i className="fa fa-plus" /> Add Facility
                            </button>
                            <br/>
                            <dt>Facilities</dt>
                            <br />  
                            <ReactTable
                              ref={(instance) => {
                                this.table = instance;
                              }}
                              pageSize={10}
                              minRows={1}
                              loading={contacts.isLoading}
                              data={contacts && contacts.facilities && contacts.facilities.list ? contacts.facilities.list : []}
                              columns={[
                                {
                                  Header: '',
                                  id: 'actions',
                                  width: 60,
                                  sortable: false,
                                  Cell: (row) => (
                                    <span>
                                      <button disabled={isExecutive}
                                        className="btn btn-default btn-xs"
                                        onClick={() =>
                                          this.showContactModal(
                                            row.original.id
                                          )
                                        }
                                      >
                                        <i className="fa fa-pencil" />
                                      </button>
                                      &nbsp;
                                      <button disabled={isStaff || isExecutive}
                                        className="btn btn-default btn-xs"
                                        onClick={() =>
                                          this.deleteContact(
                                            row.original.id,
                                          )
                                        }
                                      >
                                        <i className="fa fa-trash" />
                                      </button>
                                    </span>
                                  ),
                                },
                                {
                                  Header: 'Id',
                                  id: 'id',
                                  accessor: 'id',
                                  show: false,
                                },
                                {
                                  Header: 'Contact',
                                  accessor: 'contactName',
                                },
                                {
                                  Header: 'Company',
                                  accessor: 'company',
                                },
                                {
                                  Header: 'Phone',
                                  accessor: 'phone1',
                                },
                                {
                                  Header: 'Email',
                                  accessor: 'email',
                                },
                                {
                                  Header: 'Website',
                                  accessor: 'website',
                                },
                                {
                                  Header: 'Description',
                                  accessor: 'description',
                                },
                              ]}
                              className="-striped -highlight"
                              sortable={true}
                              defaultSorted={[
                                {
                                  id: 'contactName',
                                  asc: true,
                                },
                              ]}
                            />
                            <br />
                            <hr />
                            <dt>Facility Documents</dt>
                            <br />
                            <button disabled={isStaff}
                              className="btn btn-default"
                              onClick={this.showFacilityModal.bind(this)}>
                              <i className="fa fa-plus" /> Add Document
                            </button>
                            <ReactTable
                              ref={(instance) => {
                                this.table = instance;
                              }}
                              loading={
                                isFacilityFilesLoading || isFacilityFilesUpdating || isFacilityFilesUploading
                              }
                              minRows={1}
                              data={
                                facilityfiles[params.clinicLocationID]
                                  ? facilityfiles[params.clinicLocationID]
                                  : []
                              }
                              columns={[
                                {
                                  Header: 'Actions',
                                  Cell: (row) => (
                                    <div>
                                      <button
                                        className="btn btn-xs btn-default"
                                        onClick={() =>
                                          this.downloadFacilityFile(row.original.fileName)
                                        }
                                      >
                                        <i className="fa fa-download" />
                                      </button>
                                      {` `}
                                      <button
                                        className="btn btn-xs btn-default"
                                        onClick={() =>
                                          this.previewFacilityFile(row.original.fileName)
                                        }
                                      >
                                        <i className="fa fa-file" />
                                      </button>
                                      {` `}
                                      <button
                                        className="btn btn-xs btn-danger"
                                        onClick={() =>
                                          this.deleteFacilityFile(row.original.fileName)
                                        }
                                      >
                                        <i className="fa fa-remove" />
                                      </button>
                                    </div>
                                  ),
                                },
                                {
                                  Header: 'File',
                                  accessor: 'fileName',
                                },
                                {
                                  Header: 'Description',
                                  accessor: 'description',
                                  Cell: this.renderFacilityEditable,
                                },
                                {
                                  Header: 'DocumentType',
                                  accessor: 'documentTypeId',
                                  Cell: this.renderEditableDocumentType,
                                },
                                {
                                  Header: 'ExpirationDate',
                                  accessor: 'expirationDate',
                                  Cell: this.renderFacilityEditable,
                                },
                                {
                                  Header: 'Notify',
                                  accessor: 'isNotify',
                                  Cell: this.renderEditableNotify,
                                },
                                {
                                  Header: 'AdvanceNotice',
                                  accessor: 'advanceNotice',
                                  Cell: this.renderFacilityEditable,
                                },
                                {
                                  Header: 'Email',
                                  accessor: 'notificationEmail',
                                  Cell: this.renderFacilityEditable
                                },
                                {
                                  Header: 'Uploaded at',
                                  accessor: 'uploadAt',
                                  Cell: (row) => (
                                    <Moment
                                      date={row.original.uploadAt}
                                      format="MM/DD/YYYY hh:mm"
                                    />
                                  ),
                                },
                                {
                                  Header: 'Uploaded By',
                                  accessor: 'uploadByEmail',
                                },
                              ]}
                              className="-striped -highlight"
                              onSearchChange={this.handleSearch}
                            />
                          </div>

                          <Modal show={this.state.showFacilityUpload}>
                            <Modal.Header>
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-hidden="true"
                                onClick={this.closeModal.bind(this)}
                              >
                                &times;
                              </button>
                              <h4 className="modal-title" id="addFilesModalLabel">
                                Add Files
                              </h4>
                            </Modal.Header>
                            <Modal.Body>
                              <div className="row client-files-upload">
                                <div
                                  className={
                                    this.state.facilityfiles.length > 0
                                      ? 'col-sm-12'
                                      : 'col-sm-12'
                                  }
                                >
                                  <Dropzone
                                    accept={acceptedFiles}
                                    onDrop={this.onFacilityDrop.bind(this)}
                                    onFileDialogCancel={this.onFacilityCancel.bind(this)}
                                  >
                                    {({
                                      getRootProps,
                                      getInputProps,
                                      isDragActive,
                                    }) => {
                                      return (
                                        <div
                                          {...getRootProps()}
                                          className={classNames(
                                            'dropzone dropzone-client-files',
                                            { 'dropzone--isActive': isDragActive },
                                          )}
                                        >
                                          <input {...getInputProps()} />
                                          {isDragActive ? (
                                            <p>Drop files here...</p>
                                          ) : (
                                            <span className="text-center">
                                              <span className="font-lg visible-xs-block visible-sm-block visible-lg-block">
                                                <span className="font-lg">
                                                  Drop files{' '}
                                                  <span className="font-xs">
                                                    to upload
                                                  </span>
                                                </span>
                                                <span>
                                                  &nbsp;&nbsp;
                                                  <h4 className="display-inline">
                                                    {' '}
                                                    (Or Click)
                                                  </h4>
                                                </span>
                                              </span>
                                            </span>
                                          )}
                                        </div>
                                      );
                                    }}
                                  </Dropzone>
                                </div>
                                {this.state.facilityfiles.length > 0 && (
                                  <div className="col-sm-12">
                                    <h4>Files to be uploaded</h4>
                                    <ul className="list-group files-upload-list">
                                      {facilityfilesToUpload}
                                    </ul>
                                    {` `}
                                    {/* {this.state.files.length > 0 && <button className="btn btn-default" onClick={this.onCancel.bind(this)}>Clear</button>}{` `} */}
                                  </div>
                                )}
                              </div>
                            </Modal.Body>
                            <Modal.Footer>
                              <button
                                type="button"
                                className="btn btn-default"
                                data-dismiss="modal"
                                onClick={this.closeFacilityModal.bind(this)}
                                disabled={isFacilityFilesUploading}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary"
                                disabled={this.state.facilityfiles.length === 0}
                                onClick={this.onStartFacilityUpload.bind(this)}
                              >
                                Upload Files
                              </button>
                            </Modal.Footer>
                            {isFacilityFilesUploading && (
                              <div className="cover">
                                <div className="spinner" />
                              </div>
                            )}
                          </Modal>
                          
                          <div className="tab-pane fade" id="contacts">
                            <br />
                            <button disabled={isStaff || isExecutive}
                              className="btn btn-default"
                              onClick={() =>
                                this.showContactForm('00000000-0000-0000-0000-000000000000', 'Add', this.props.params.clinicLocationID)
                              }
                            >
                              <i className="fa fa-plus" /> Add Contact
                            </button>
                            <br />
                            <ReactTable
                              ref={(instance) => {
                                this.table = instance;
                              }}
                              pageSize={10}
                              minRows={1}
                              loading={contacts && contacts.isLoading}
                              data={contacts && contacts.data && contacts.data.list ? contacts.data.list : []
                              }
                              onFetchData={this.fetchData}
                              defaultSorted={[
                                {
                                  id: 'contactName',
                                  desc: false,
                                },
                              ]}
                              columns={[
                                {
                                  Header: '',
                                  id: 'actions',
                                  width: 50,
                                  sortable: false,
                                  Cell: (row) => (
                                    <span>
                                      <button disabled={isExecutive}
                                        className="btn btn-default btn-xs"
                                        onClick={() =>
                                          this.showContactForm(
                                            row.original.contact.id, 'Edit', this.props.params.clinicLocationID
                                          )
                                        }
                                      >
                                        <i className="fa fa-pencil" />
                                      </button>
                                    </span>
                                  ),
                                },
                                {
                                  Header: 'ID',
                                  id: 'id',
                                  accessor: 'id',
                                  show: false,
                                },
                                {
                                  Header: 'Contact',
                                  id: 'contact.contactName',
                                  accessor: 'contact.contactName',
                                  Cell: (row) => (
                                    <a
                                      onClick={() =>
                                        this.showContactForm(
                                          row.original.contact.id, 'ReadOnly', this.props.params.clinicLocationID
                                        )
                                      }
                                    >
                                      {row.original.contact.contactName}
                                    </a>
                                  ),
                                },
                                {
                                  Header: 'Company',
                                  id: 'contact.company',
                                  accessor: 'contact.company',
                                },
                                {
                                  Header: 'Phone',
                                  id: 'contact.phone1',
                                  accessor: 'contact.phone1',
                                },
                                {
                                  Header: 'Email',
                                  id: 'contact.email1',
                                  accessor: 'contact.email1',
                                },
                                {
                                  Header: 'Website',
                                  id: 'contact.website',
                                  accessor: 'contact.website',
                                },
                                {
                                  Header: 'Description',
                                  id: 'contact.description',
                                  accessor: 'contact.description',
                                },
                              ]}
                              className="-striped -highlight"
                              onSearchChange={this.handleSearch}
                            />
                          </div>

                        </div>
                        <hr />
                        <br />
                        {/*Files Section*/}
                        <h3>
                          Files{' '}
                          <button disabled={isExecutive}
                            className="btn btn-default"
                            onClick={this.showLocationModal.bind(this)}
                          >
                            <i className="fa fa-plus" /> Add Files
                          </button>
                        </h3>
                        <br />
                        <Modal show={this.state.showlocationUpload}>
                          <Modal.Header>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-hidden="true"
                              onClick={this.closeLocationModal.bind(this)}
                            >
                              &times;
                            </button>
                            <h4 className="modal-title" id="addFilesModalLabel">
                              Add Files
                            </h4>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="row client-files-upload">
                              <div
                                className={
                                  this.state.locationfiles.length > 0
                                    ? 'col-sm-12'
                                    : 'col-sm-12'
                                }
                              >
                                <Dropzone
                                  accept={locationacceptedFiles}
                                  onDrop={this.onLocationDrop.bind(this)}
                                  onFileDialogCancel={this.onLocationCancel.bind(
                                    this,
                                  )}
                                >
                                  {({
                                    getRootProps,
                                    getInputProps,
                                    isDragActive,
                                  }) => {
                                    return (
                                      <div
                                        {...getRootProps()}
                                        className={classNames(
                                          'dropzone dropzone-client-files',
                                          {
                                            'dropzone--isActive': isDragActive,
                                          },
                                        )}
                                      >
                                        <input {...getInputProps()} />
                                        {isDragActive ? (
                                          <p>Drop files here...</p>
                                        ) : (
                                          <span className="text-center">
                                            <span className="font-lg visible-xs-block visible-sm-block visible-lg-block">
                                              <span className="font-lg">
                                                Drop files{' '}
                                                <span className="font-xs">
                                                  to upload
                                                </span>
                                              </span>
                                              <span>
                                                &nbsp;&nbsp;
                                                <h4 className="display-inline">
                                                  {' '}
                                                  (Or Click)
                                                </h4>
                                              </span>
                                            </span>
                                          </span>
                                        )}
                                      </div>
                                    );
                                  }}
                                </Dropzone>
                              </div>
                              {this.state.locationfiles.length > 0 && (
                                <div className="col-sm-12">
                                  <h4>Files to be uploaded</h4>
                                  <ul className="list-group files-upload-list">
                                    {locationfilesToUpload}
                                  </ul>
                                  {` `}
                                  {/* {this.state.files.length > 0 && <button className="btn btn-default" onClick={this.onCancel.bind(this)}>Clear</button>}{` `} */}
                                </div>
                              )}
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <button
                              type="button"
                              className="btn btn-default"
                              data-dismiss="modal"
                              onClick={this.closeLocationModal.bind(this)}
                              disabled={isLocationFilesUploading}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              disabled={this.state.locationfiles.length === 0}
                              onClick={this.onStartLocationUpload.bind(this)}
                            >
                              Upload Files
                            </button>
                          </Modal.Footer>
                          {isLocationFilesUploading && (
                            <div className="cover">
                              <div className="spinner" />
                            </div>
                          )}
                        </Modal>
                        <div
                          className="modal fade"
                          id="addFilesModal"
                          tabIndex="-1"
                          role="dialog"
                          aria-labelledby="addFilesModalLabel"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="modal-header" />
                              <div className="modal-body" />
                              <div className="modal-footer" />
                            </div>
                            {/* /.modal-content */}
                          </div>
                          {/* /.modal-dialog */}
                        </div>
                        {/* /.modal */}

                        <ReactTable
                          ref={(instance) => {
                            this.table = instance;
                          }}
                          loading={
                            isFilesLoading ||
                            isFileUpdating ||
                            isLocationFilesUploading
                          }
                          minRows={1}
                          data={
                            locationfiles[params.clinicLocationID]
                              ? locationfiles[params.clinicLocationID]
                              : []
                          }
                          columns={[
                            {
                              Header: 'Actions',
                              Cell: (row) => (
                                <div>
                                  <button disabled={isExecutive}
                                    className="btn btn-xs btn-default"
                                    onClick={() =>
                                      this.downloadFile(row.original.fileName)
                                    }
                                  >
                                    <i className="fa fa-download" />
                                  </button>
                                  {` `}
                                  <button disabled={isExecutive}
                                    className="btn btn-xs btn-default"
                                    onClick={() =>
                                      this.previewFile(row.original.fileName)
                                    }
                                  >
                                    <i className="fa fa-file" />
                                  </button>
                                  {` `}
                                  <button disabled={isExecutive}
                                    className="btn btn-xs btn-danger"
                                    onClick={() =>
                                      this.deleteFile(row.original.fileName)
                                    }
                                  >
                                    <i className="fa fa-remove" />
                                  </button>
                                </div>
                              ),
                            },
                            {
                              Header: 'File',
                              accessor: 'fileName',
                            },
                            {
                              Header: 'Title',
                              accessor: 'title',
                              Cell: this.renderEditable,
                            },
                            {
                              Header: 'Description',
                              accessor: 'description',
                              Cell: this.renderEditable,
                            },
                            {
                              Header: 'Tags',
                              accessor: 'tags',
                              Cell: this.renderEditableTags,
                              // Cell: row => row.original.tags ? row.original.tags.join() : '',
                            },
                            {
                              Header: 'Uploaded at',
                              accessor: 'uploadAt',
                              Cell: (row) => (
                                <Moment
                                  date={row.original.uploadAt}
                                  format="MM/DD/YYYY hh:mm"
                                />
                              ),
                            },
                            {
                              Header: 'Uploaded By',
                              accessor: 'uploadByEmail',
                            },
                          ]}
                          className="-striped -highlight"
                          onSearchChange={this.handleSearch}
                        />
                        <hr className="simple" />
                        <Modal
                          show={this.state.showPreview || this.state.showFacilityPreview}
                          dialogClassName="modal-lg"
                        >
                          <Modal.Header>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-hidden="true"
                              onClick={this.closePreview.bind(this)}
                            >
                              &times;
                            </button>
                            <h4 className="modal-title">File Viewer</h4>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="widget-body">
                              {
                                <FileViewer
                                  fileType={this.state.fileType}
                                  filePath={this.state.fileName}
                                />
                              }
                            </div>
                          </Modal.Body>
                        </Modal>
                      </div>
                    </div>
                    {/* THIS SCHEDULE SECTION IS SOMETHING WE NEED TO CREATE - IT DOES NOT EXIST YET */}
                    <div className="col-lg-5 col-sm-12 col-xs-12 ">
                      <h3>Hours of Operation</h3>
                      <br />
                      {info && info.schedule && (
                        <div className="table-responsive">
                          <table className="table table-bordered table-condensed">
                            <thead>
                              <tr>
                                <th>Day</th>
                                <th>Open</th>
                                <th>Close</th>
                                <th>Hours</th>
                              </tr>
                            </thead>
                            <tbody>
                              {info.schedule.sundayOpen !==
                                info.schedule.sundayClose && (
                                <tr>
                                  <td>Sunday</td>
                                  <td>{info.schedule.sundayOpen}</td>
                                  <td>{info.schedule.sundayClose}</td>
                                  <td>{info.schedule.sunday}</td>
                                </tr>
                              )}
                              {info.schedule.sundayOpen ===
                                info.schedule.sundayClose && (
                                <tr>
                                  <td>Sunday</td>
                                  <td colSpan={3}>Closed</td>
                                </tr>
                              )}
                              {info.schedule.mondayOpen !==
                                info.schedule.mondayClose && (
                                <tr>
                                  <td>Monday</td>
                                  <td>{info.schedule.mondayOpen}</td>
                                  <td>{info.schedule.mondayClose}</td>
                                  <td>{info.schedule.monday}</td>
                                </tr>
                              )}
                              {info.schedule.mondayOpen ===
                                info.schedule.mondayClose && (
                                <tr>
                                  <td>Monday</td>
                                  <td colSpan={3}>Closed</td>
                                </tr>
                              )}
                              {info.schedule.tuesdayOpen !==
                                info.schedule.tuesdayClose && (
                                <tr>
                                  <td>Tuesday</td>
                                  <td>{info.schedule.tuesdayOpen}</td>
                                  <td>{info.schedule.tuesdayClose}</td>
                                  <td>{info.schedule.tuesday}</td>
                                </tr>
                              )}
                              {info.schedule.tuesdayOpen ===
                                info.schedule.tuesdayClose && (
                                <tr>
                                  <td>Tuesday</td>
                                  <td colSpan={3}>Closed</td>
                                </tr>
                              )}
                              {info.schedule.wednesdayOpen !==
                                info.schedule.wednesdayClose && (
                                <tr>
                                  <td>Wednesday</td>
                                  <td>{info.schedule.wednesdayOpen}</td>
                                  <td>{info.schedule.wednesdayClose}</td>
                                  <td>{info.schedule.wednesday}</td>
                                </tr>
                              )}
                              {info.schedule.wednesdayOpen ===
                                info.schedule.wednesdayClose && (
                                <tr>
                                  <td>Wednesday</td>
                                  <td colSpan={3}>Closed</td>
                                </tr>
                              )}
                              {info.schedule.thursdayOpen !==
                                info.schedule.thursdayClose && (
                                <tr>
                                  <td>Thursday</td>
                                  <td>{info.schedule.thursdayOpen}</td>
                                  <td>{info.schedule.thursdayClose}</td>
                                  <td>{info.schedule.thursday}</td>
                                </tr>
                              )}
                              {info.schedule.thursdayOpen ===
                                info.schedule.thursdayClose && (
                                <tr>
                                  <td>Thursday</td>
                                  <td colSpan={3}>Closed</td>
                                </tr>
                              )}
                              {info.schedule.fridayOpen !==
                                info.schedule.fridayClose && (
                                <tr>
                                  <td>Friday</td>
                                  <td>{info.schedule.fridayOpen}</td>
                                  <td>{info.schedule.fridayClose}</td>
                                  <td>{info.schedule.friday}</td>
                                </tr>
                              )}
                              {info.schedule.fridayOpen ===
                                info.schedule.fridayClose && (
                                <tr>
                                  <td>Friday</td>
                                  <td colSpan={3}>Closed</td>
                                </tr>
                              )}
                              {info.schedule.saturdayOpen !==
                                info.schedule.saturdayClose && (
                                <tr>
                                  <td>Saturday</td>
                                  <td>{info.schedule.saturdayOpen}</td>
                                  <td>{info.schedule.saturdayClose}</td>
                                  <td>{info.schedule.saturday}</td>
                                </tr>
                              )}
                              {info.schedule.saturdayOpen ===
                                info.schedule.saturdayClose && (
                                <tr>
                                  <td>Saturday</td>
                                  <td colSpan={3}>Closed</td>
                                </tr>
                              )}
                            </tbody>
                            <thead>
                              <tr>
                                <th colSpan={3}>Total</th>
                                <th>
                                  {+info.schedule.sunday +
                                    info.schedule.monday +
                                    info.schedule.tuesday +
                                    info.schedule.wednesday +
                                    info.schedule.thursday +
                                    info.schedule.friday +
                                    info.schedule.saturday}
                                </th>
                              </tr>
                            </thead>
                          </table>
                        </div>
                      )}
                      {info && !info.schedule && <div>N/A</div>}
                      <br />
                      <h3>
                        Photo Gallery{' '}
                        <button disabled={isExecutive}
                          className="btn btn-default"
                          onClick={this.showModal.bind(this)}
                        >
                          <i className="fa fa-plus" /> Add Files
                        </button>
                      </h3>
                      <br />
                      <Gallery
                        images={this.state.gallery}
                        currentImageWillChange={this.onCurrentImageChange}
                        customControls={[
                          <button disabled={isExecutive}
                            className="btn btn-danger"
                            key="deleteImage"
                            onClick={this.deleteImage}
                          >
                            Delete Image
                          </button>,
                        ]}
                      />
                      <Modal show={this.state.showUpload}>
                        <Modal.Header>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            onClick={this.closeModal.bind(this)}
                          >
                            &times;
                          </button>
                          <h4 className="modal-title" id="addFilesModalLabel">
                            Add Files
                          </h4>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="row client-files-upload">
                            <div
                              className={
                                this.state.files.length > 0
                                  ? 'col-sm-12'
                                  : 'col-sm-12'
                              }
                            >
                              <Dropzone
                                accept={acceptedFiles}
                                onDrop={this.onDrop.bind(this)}
                                onFileDialogCancel={this.onCancel.bind(this)}
                              >
                                {({
                                  getRootProps,
                                  getInputProps,
                                  isDragActive,
                                }) => {
                                  return (
                                    <div
                                      {...getRootProps()}
                                      className={classNames(
                                        'dropzone dropzone-client-files',
                                        { 'dropzone--isActive': isDragActive },
                                      )}
                                    >
                                      <input {...getInputProps()} />
                                      {isDragActive ? (
                                        <p>Drop files here...</p>
                                      ) : (
                                        <span className="text-center">
                                          <span className="font-lg visible-xs-block visible-sm-block visible-lg-block">
                                            <span className="font-lg">
                                              Drop files{' '}
                                              <span className="font-xs">
                                                to upload
                                              </span>
                                            </span>
                                            <span>
                                              &nbsp;&nbsp;
                                              <h4 className="display-inline">
                                                {' '}
                                                (Or Click)
                                              </h4>
                                            </span>
                                          </span>
                                        </span>
                                      )}
                                    </div>
                                  );
                                }}
                              </Dropzone>
                            </div>
                            {this.state.files.length > 0 && (
                              <div className="col-sm-12">
                                <h4>Files to be uploaded</h4>
                                <ul className="list-group files-upload-list">
                                  {filesToUpload}
                                </ul>
                                {` `}
                                {/* {this.state.files.length > 0 && <button className="btn btn-default" onClick={this.onCancel.bind(this)}>Clear</button>}{` `} */}
                              </div>
                            )}
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <button
                            type="button"
                            className="btn btn-default"
                            data-dismiss="modal"
                            onClick={this.closeModal.bind(this)}
                            disabled={isFilesUploading}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            disabled={this.state.files.length === 0}
                            onClick={this.onStartUpload.bind(this)}
                          >
                            Upload Files
                          </button>
                        </Modal.Footer>
                        {isFilesUploading && (
                          <div className="cover">
                            <div className="spinner" />
                          </div>
                        )}
                      </Modal>

                      <Modal show={this.state.showClinicShutdown}>
                        <Modal.Header>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            onClick={this.closeClinicShutdownModal.bind(this)}
                          >
                            &times;
                          </button>
                          <h4 className="modal-title">Clinic Shutdown Hours</h4>
                        </Modal.Header>
                        <Modal.Body>
                          <ClinicShutdownForm onSubmit={this.onSubmit} />
                        </Modal.Body>
                      </Modal>

                      <Modal
                        show={this.state.showContactForm}
                        dialogClassName="modal-lg"
                      >
                        <Modal.Header>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            onClick={this.closeContactForm.bind(this)}
                          >
                            &times;
                          </button>
                          <h4 className="modal-title">Add/Edit Facility</h4>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="widget-body">
                            {
                              <ContactForm
                                searchContactTypes={this.searchContactTypes}
                                searchClients={this.searchClients}
                                searchPatients={this.searchPatients}
                                searchLocations={this.searchLocations}
                                searchReferrals={this.searchReferrals}
                                mode={this.props.params.mode}
                                onSubmit={this.onFormSubmit}
                                onCancel={this.onFormCancel}
                              />
                            }
                          </div>
                        </Modal.Body>
                      </Modal>

                    </div>
                  </div>
                )}
                {isDetailsLoading && (
                  <div className="cover">
                    <div className="spinner" />
                  </div>
                )}
              </div>
              {/* end product */}
            </div>
          )}
        </div>
        <div ref={(el) => (this.disposal = el)} className="disposal" />
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.locationmanager,
    user: state.currentUser,
    contacts: state.contactmanager,
    isStaff: isStaff(state),
    isExecutive: isExecutive(state),
  }),
  (dispatch) => ({
    getCurrentUser: () => dispatch(requestUserInfo()),
    getLocationDetails: (clinicLocationID, params) =>
      dispatch(requestLocationDetails(clinicLocationID, params)),
    getPhotoGalleryFiles: (locationCode, params) =>
      dispatch(requestLocationPhotoGalleryFiles(locationCode, params)),
    uploadPhotoGalleryFiles: (locationCode, params, files) =>
      dispatch(uploadLocationPhotoGalleryFiles(locationCode, params, files)),
    getPhotoGalleryFile: (locationCode, params, file) =>
      dispatch(getLocationPhotoGalleryFile(locationCode, params, file)),
    deletePhotoGalleryFile: (locationCode, params, file) =>
      dispatch(deleteLocationPhotoGalleryFile(locationCode, params, file)),
    getLocationShutdownHours: (clinicLocationID, params) =>
      dispatch(requestShutdownHours(clinicLocationID, params)),
    updateShutdownHours: (clinicLocationID, params) =>
      dispatch(updateShutdownHours(clinicLocationID, params)),
    getLocationFiles: (locationCode, params) =>
      dispatch(requestLocationFiles(locationCode, params)),
    uploadLocationFiles: (locationCode, params, files) =>
      dispatch(uploadLocationFiles(locationCode, params, files)),
    getLocationFile: (locationCode, params, file) =>
      dispatch(getLocationFile(locationCode, params, file)),
    previewLocationFile: (locationCode, params, file) =>
      dispatch(previewLocationFile(locationCode, params, file)),
    deleteLocationFile: (locationCode, params, file) =>
      dispatch(deleteLocationFile(locationCode, params, file)),
    updateLocationFileInfo: (locationCode, file, params, data) =>
      dispatch(updateLocationFileDescription(locationCode, file, params, data)),
    getLocationContacts: (clinicLocationID, params) =>
      dispatch(requestLocationContacts(clinicLocationID, params)),
    getContact: (contactId, params) => dispatch(requestContactDetails(contactId, params)),
    getContactTypes: (params) => dispatch(requestContactTypes(params)),
    clientsTypeahead: (params) => dispatch(requestClientsTypeahead(params)),
    patientsTypeahead: (params) => dispatch(requestPatientsTypeahead(params)),
    locationsTypeahead: (params) => dispatch(requestClinicLocationsTypeahead(params)),
    referralsTypeahead: (params) => dispatch(requestReferralsTypeahead(params)),
    updateContactDetails: (contact, params) => dispatch(updateContactDetails(contact, params)),
    getFacilities: (params) => dispatch(requestFacilityContacts(params)),
    deleteFacilityContact: (contactId, params) => dispatch(deleteFacilityContact(contactId, params)),
    getDocumentTypes: (params) => dispatch(requestDocumentTypes(params)),
    getFacilityFiles: (locationCode, params) => dispatch(requestLocationFacilityFiles(locationCode, params)),
    uploadFacilityFiles: (locationCode, params, files) => dispatch(uploadLocationFacilityFiles(locationCode, params, files)),
    getFacilityFile: (locationCode, params, file) => dispatch(getFacilityFile(locationCode, params, file)),
    previewFacilityFile: (locationCode, params, file) => dispatch(previewFacilityFile(locationCode, params, file)),
    deleteFacilityFile: (locationCode, params, file) => dispatch(deleteFacilityFile(locationCode, params, file)),
    updateFacilityFileInfo: (locationCode, file, params, data) => 
      dispatch(updateFacilityFileInfo(locationCode, file, params, data)),
  }),
)(LocationManagerDetail);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/LocationManagerDetail.js